//# 把后端传的时间，去掉秒 2021-1-29 17:26:50 -> 2021-1-29 17:26
export function sliceSecondFormat(v) {
  if (!v) return '--';
  return v.split(':').slice(0, 2).join(':');
}

//# 把后端传的时间，去掉时间 2021-1-29 17:26:50 -> 2021-1-29
export function sliceTimeFormat(v) {
  if (!v) return '--';
  return v.split(' ')[0];
}

export function tableFormatSeqFlag(v) {
  let r = '--';
  const action = new Map([
    [/^0$/, () => (r = '充值')],
    [/^1$/, () => (r = '消费')],
  ]);

  let res = [...action].filter(([key, value]) => key.test(v));
  if (res.length === 0) return r;
  res.forEach(([key, value]) => value.call(this));
  return r;
}

export function tableFormatRechargeSource(v) {
  let r = '--';
  const action = new Map([
    [/^0$/, () => (r = '扫码')],
    [/^1$/, () => (r = '支付宝')],
    [/^2$/, () => (r = '网银')],
    [/^3$/, () => (r = '收益')],
    [/^4$/, () => (r = '爱易佰钱包')],
    [/^5$/, () => (r = '专用钱包')],
    [/^6$/, () => (r = '代理商')],
    [/^7$/, () => (r = '商学院')],
    [/^8$/, () => (r = '佣金')],
    [/^10$/, () => (r = '佣金')],
  ]);

  let res = [...action].filter(([key, value]) => key.test(v));
  if (res.length === 0) return r;
  res.forEach(([key, value]) => value.call(this));
  return r;
}

export function tableFormatOrderStatus(v) {
  let r = '--';
  const action = new Map([
    [/^0$/, () => (r = '已完成')],
    [/^1$/, () => (r = '待付款')],
    [/^2$/, () => (r = '交易失败')],
    [/^3$/, () => (r = '已取消')],
    [/^4$/, () => (r = '提现中')],
  ]);

  let res = [...action].filter(([key, value]) => key.test(v));
  if (res.length === 0) return r;
  res.forEach(([key, value]) => value.call(this));
  return r;
}

//# 数字取两位小数
export function numToFixed02(v1, v2) {
  if (v1 === null || v1 === undefined) return '0.00';
  if (!v2) {
    return v1.toFixed(2);
  }
  let num = v1 + v2;
  return num.toFixed(2);
}

//# 空值检测
export function emptyText(v) {
  if (v !== 0 && (!v || v === '')) return '--';
  return v;
}

//# 管理员等级权限 文字
export function adminRole(v) {
  switch (v) {
    case -1:
      return '禁用';
    case 1:
      return '超级管理员';
    case 2:
      return '产品';
    case 3:
      return '财务';
    case 4:
      return '销售';
    default:
      return '其他';
      break;
  }
}

//# 充值审核 - 汇款途径
export function remittanceText(v) {
  let r = '--';
  const action = new Map([
    [/^1$/, () => (r = '银行汇款')],
    [/^2$/, () => (r = '扫码支付')],
    [/^3$/, () => (r = '支付宝支付')],
    [/^4$/, () => (r = '现金支付')],
    [/^5$/, () => (r = '财付通')],
    [/^6$/, () => (r = '网上银行转账')],
    [/^7$/, () => (r = '免费赠送')],
  ]);

  let res = [...action].filter(([key, value]) => key.test(v));
  if (res.length === 0) return r;
  res.forEach(([key, value]) => value.call(this));
  return r;
}

export function tableFormatAgentFlag(v) {
  let r = '--';
  const action = new Map([
    [/^2$/, () => (r = '省级')],
    [/^3$/, () => (r = '市级')],
    [/^4$/, () => (r = '区/县级')],
    [/^5$/, () => (r = '乡镇/街道级')],
    [/^6$/, () => (r = '校级')],
    [/^7$/, () => (r = '同事')],
    [/^8$/, () => (r = '合伙人')],
  ]);

  let res = [...action].filter(([key, value]) => key.test(v));
  if (res.length === 0) return r;
  res.forEach(([key, value]) => value.call(this));
  return r;
}

export function walletCodeText(val) {
  switch (val) {
    case 'ASD':
      return '艾速度';
    case 'CPX':
      return '评测学';
    case 'SS':
      return '远程督导';
    default:
      return '--';
  }
}



// WEBPACK FOOTER //
// ./src/filters/filters.js